import { AdvertFuseRequest } from './ad-logic/advert-fuse-request.js';
import { AdvertFuseCore } from './advert-fuse-core.js';
import { IAdvertFuseProps } from './types.js';

export type AdvertRawProps = Omit<
  IAdvertFuseProps,
  'queryParams' | 'genericTargeting' | 'overrideBaseTargeting' | 'mergeBaseTargeting'
>;
/** All targeting and query params are already sorted */
export type AdOriginType =
  | 'adv-module'
  | 'adv-interstitial'
  | 'adv-banner'
  | 'adv-mapTakeover'
  | 'adv-skinRight'
  | 'adv-skinLeft';

/**
 * Builds dom element based on fuse props
 */
export const AdvertFuse = ({
  fuseTag,
  adUnitPath,
  origin,
  targeting = [],
  adDisplayTrueCB,
  forceMrecSpace,
}: AdvertRawProps) => {
  const fuseDataAttr = targeting.reduce<Record<string, string>>((acc, { key, value }) => {
    if (value) {
      acc[`data-targeting-${key.toLowerCase()}`] = value;
    }
    return acc;
  }, {});

  return (
    <AdvertFuseRequest
      origin={origin}
      adDisplayTrueCB={adDisplayTrueCB}
      fuseDataAttr={fuseDataAttr}
      adUnitPath={adUnitPath}
      fuseTag={fuseTag}
    >
      <AdvertFuseCore forceMrecSpace={forceMrecSpace} fuseTag={fuseTag} fuseDataAttr={fuseDataAttr} origin={origin} />
    </AdvertFuseRequest>
  );
};
